export enum InvoiceMovementsRoutesEnum{
    PREFIX             = 'INVOICE_MOVEMENTS',
    INVOICE_MOVEMENTS_LIST      = 'INVOICE_MOVEMENTS_LIST',
    INVOICE_MOVEMENT_DETAIL    = 'INVOICE_MOVEMENTS_DETAIL'
}